import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-quiz-answer-number',
  templateUrl: './view-quiz-answer-number.component.html',
  styleUrls: ['./view-quiz-answer-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizAnswerNumberComponent implements OnInit {

  @Input()
  number: number;

  constructor() { }

  ngOnInit(): void {
  }

}
